export default __webpack_public_path__ + "static/media/insight.5e16bfc9.svg";